import { Component, Input,   forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Component({
  selector: 'app-ng-dropdown',
  templateUrl: './ng-dropdown.component.html',
  styleUrls: ['./ng-dropdown.component.css'],
   providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NgDropdownComponent),
      multi: true
    }
  ]
})
export class NgDropdownComponent implements ControlValueAccessor {
  @Input() options: any[] = [];
  @Input() optionLabel: string = "";
  @Input() placeholder: string = "";
  @Input() showClear: boolean = false;
  @Input() virtualScroll: boolean = false;
  @Input() virtualScrollItemSize: number = 20;


    value: any;

  onChange = (_: any) => {};
  onTouched = () => {};

  writeValue(val: any): void {
    this.value = val;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Optional: implement if you want to support [disabled]
  }

  onValueChange(event: any) {
    this.value = event;
    this.onChange(event);
    this.onTouched();
  }
  
}
